import PropTypes from "prop-types";
import { DatePicker } from "components/DatePicker";
import { useDatepickerErrorState } from "hooks/datepicker/useDatepickerErrorState";

/**
 * A date picker for selecting the end date
 * @param startDate the currently selected start date
 * @param endDate the currently selected end date
 * @param onChange the function to call when a new end date is selected
 * @param label The label of to display in the input
 * @param datePickerParams material ui date picker params
 * @returns {JSX.Element} a date picker
 */
export const EndDatePicker = ({
  startDate,
  endDate,
  onChange,
  label = "Date to",
  ...datePickerParams
}) => {
  const { setError, errorMessage } = useDatepickerErrorState();

  return (
    <DatePicker
      id="end-date-input"
      data-qa="AP-Date-Picker-End-Date"
      label={label}
      date={endDate}
      fullWidth
      onChange={onChange}
      onError={error => setError(error)}
      helperText={errorMessage}
      //don't allow user to select below the start date
      minDate={startDate ?? undefined}
      //focus on start date if a date isn't currently selected
      initialFocusedDate={startDate}
      ariaLabel="change end date"
      {...datePickerParams}
    />
  );
};

EndDatePicker.propTypes = {
  /** The currently selected start date */
  startDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]),
  /** The currently selected end date */
  endDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]),
  /** The function to call when a new end date is selected */
  onChange: PropTypes.func,
  /** The label of to display in the input */
  label: PropTypes.string
};
